import React, { useState } from "react";

import "./../../../assets/scss/style.scss";
import Aux from "../../../hoc/_Aux";
import { connect } from "react-redux";
import axios from "axios";
import { APP_CONSTANTS } from "../../../App/utils/app_constants";
import cx from "classnames";
import { loginSucced, loginFailed } from "../../../store/_actions/auth";
import Fade from "react-reveal/Fade";
import { useForm } from "react-hook-form";
import { useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import { setCookie } from "../../../App/utils/session";
const ResetPassword = (props) => {
  const [pwType, setPwType] = useState("");
  const [credential, setCredential] = useState({});
  const [activeStep, setActiveStep] = useState(1);
  const { register, handleSubmit, errors } = useForm();

  const onPwTypeClick = (type) => setPwType(type);

  const onResetPassword = async (data) => {
    try {
      const { username, phone } = data;
      if (username) {
        let obj = Object.assign(credential, {
          username,
          type: phone ? "mobile" : "email",
        });
        setCredential(obj);
        console.log(credential, phone);

        const result = await axios.post(`${APP_CONSTANTS.API_URL}/pwreset`, {
          username: username,
          pw_type: "email",
        });
        if (result.data.status) {
          setActiveStep(2);
          toast.success(result.data.massege);
        } else {
          toast.error(result.data.massege);
        }
      } else {
        let obj = Object.assign(credential, {
          username: phone,
          type: phone ? "mobile" : "email",
        });
        setCredential(obj);
        console.log(credential);

        const result = await axios.post(`${APP_CONSTANTS.API_URL}/pwreset`, {
          username: phone,
          pw_type: "mobile",
        });
        if (result.data.status) {
          setActiveStep(2);
          toast.success(result.data.massege);
        } else {
          toast.error(result.data.massege);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const resetPassowrd = async (data) => {
    const { new_password, code, password_again } = data;
    if (new_password !== password_again) {
      toast.error("رمز عبور و تکرار رمز عبور یکسان نیست");
    }
    const result = await axios.post(
      `${APP_CONSTANTS.API_URL}/pwreset-validate`,
      {
        username: credential.username,
        pw_type: credential.type,
        pw_code: code,
        new_password,
        password_again,
      }
    );
    if (result.data.status) {
      toast.success("رمز عبور با موفقیت تغییر کرد");
      setCookie("jwt", result.data.token);
      setTimeout(() => {
        props.onLoginSuccess(result.data.token);
        if (props.url.redirectTo !== "") {
          props.history.push(props.url.redirectTo);
        } else {
          props.history.push("/");
        }
      }, 4000);
    }
  };

  useEffect(() => {
    Object.values(errors).map((err) => toast.error(err.message));
  }, [errors]);
  return (
    <Aux>
      <div
        className="auth-wrapper aut-bg-img-side cotainer-fiuid align-items-stretch"
        dir="rtl"
      >
        <div className="row align-items-center w-100 align-items-stretch bg-white">
          <div className="col-lg-4 align-items-stret h-100 align-items-center d-flex justify-content-center">
            <div className=" auth-content text-center">
              <div className="mb-4">
                <i className="feather icon-lock auth-icon" />
              </div>
              <h3 className="mb-4">بازیابی رمز عبور</h3>
              {activeStep === 1 && (
                <p className="d-block">
                  با کدامیک از روش های زیر مایل هستید حساب کاربری خود را بازیابی
                  کنید
                </p>
              )}
              {activeStep === 1 && (
                <div className="pw-type-container">
                  <div
                    className={cx("pw-type-item", {
                      active: pwType === "email",
                    })}
                    onClick={() => onPwTypeClick("email")}
                  >
                    <div className="pwt-type-icon">
                      <i className="feather icon-mail"></i>
                    </div>
                    <div className="pw-type-title">
                      <strong>ایمیل</strong>
                    </div>
                  </div>
                  <div
                    className={cx("pw-type-item", {
                      active: pwType === "phone",
                    })}
                    onClick={() => onPwTypeClick("phone")}
                  >
                    <div className="pwt-type-icon">
                      <i className="feather icon-phone"></i>
                    </div>
                    <div className="pw-type-title">
                      <strong>شماره موبایل</strong>
                    </div>
                  </div>
                </div>
              )}
              <div className="pw-reset-form">
                {pwType === "email" && activeStep === 1 && (
                  <Fade bottom>
                    <div className="email-way">
                      <form onSubmit={handleSubmit(onResetPassword)}>
                        <div className="form-group mb-3">
                          <label className="d-block text-right" htmlFor="email">
                            ایمیل
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="email"
                            placeholder="ایمیل حساب کاربری خود را وارد کنید"
                            name="username"
                            ref={register({
                              required: "آدرس ایمیل الزامی است",
                            })}
                          />
                        </div>
                        <div className="mb-3">
                          <button
                            type="submit"
                            className="btn btn-dark btn-block m-0"
                          >
                            بازیابی رمز عبور
                          </button>
                        </div>
                      </form>
                    </div>
                  </Fade>
                )}
                {pwType === "phone" && activeStep === 1 && (
                  <Fade bottom>
                    <div className="mobile-way">
                      <form onSubmit={handleSubmit(onResetPassword)}>
                        <div className="form-group mb-3">
                          <label className="d-block text-right" htmlFor="tel">
                            شماره موبایل
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="tel"
                            placeholder="شماره تلفن حساب کاربری خود را وارد کنید"
                            name="phone"
                            ref={register({
                              required: "شماره تفلن الزامی است",
                            })}
                          />
                        </div>
                        <div className="mb-3">
                          <button
                            type="submit"
                            className="btn btn-dark btn-block m-0"
                          >
                            بازیابی رمز عبور
                          </button>
                        </div>
                      </form>
                    </div>
                  </Fade>
                )}
                {activeStep === 2 && (
                  <Fade bottom>
                    <form onSubmit={handleSubmit(resetPassowrd)}>
                      <div className="form-group mb-3">
                        <label className="d-block text-right" htmlFor="code">
                          کد ارسال شده را وارد کنید
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="code"
                          placeholder="کد ارسال شده را وارد کنید"
                          name="code"
                          ref={register({
                            required: "کد تایید ارسال شده را وارد کنید",
                          })}
                        />
                      </div>

                      <div className="form-group mb-3">
                        <label
                          className="d-block text-right"
                          htmlFor="new_password"
                        >
                          رمز عبور جدید
                        </label>
                        <input
                          type="password"
                          className="form-control"
                          id="new_password"
                          placeholder="****"
                          name="new_password"
                          ref={register({
                            required: "رمز عبور جدید خود را وارد کنید",
                            minLength: {
                              value: 6,
                              message: "رمز عبور باید حداقل ۶ کارکتر باشد",
                            },
                          })}
                        />
                      </div>
                      <div className="form-group mb-3">
                        <label
                          className="d-block text-right"
                          htmlFor="password_again"
                        >
                          تکرار رمز عبور جدید
                        </label>
                        <input
                          type="password"
                          className="form-control"
                          id="password_again"
                          placeholder="****"
                          name="password_again"
                          ref={register({
                            required: "تکرار رمز عبور جدید خود را وارد کنید",
                            minLength: {
                              value: 6,
                              message: "رمز عبور باید حداقل ۶ کارکتر باشد",
                            },
                          })}
                        />
                      </div>
                      <button
                        className="btn btn-dark btn-block mr-0 mb-3"
                        type="submit"
                      >
                        بازیابی رمز عبور
                      </button>
                      <div className="back-button">
                        <button
                          className="btn btn-link"
                          type="button"
                          onClick={() => setActiveStep(1)}
                        >
                          <i
                            className="feather icon-arrow-right ml-3"
                            style={{ verticalAlign: "sub" }}
                          ></i>
                          مرحله قبل
                        </button>
                      </div>
                    </form>
                  </Fade>
                )}
              </div>

              <p
                className="link mb-0 text-muted"
                onClick={() => props.history.push("/register")}
              >
                حساب کاربری ندارید؟ <strong>ثبت نام</strong>
              </p>

              <p
                className="link mb-4 text-muted"
                onClick={() => props.history.push("/login")}
              >
                حساب کاربری دارید؟ <strong>وارد شوید</strong>
              </p>
            </div>
          </div>
          <div
            className="d-none d-lg-flex col-lg-8 aut-bg-img align-items-center d-flex justify-content-center"
            style={{
              backgroundSize: "cover",
              backgroundAttachment: "fixed",
              backgroundPosition: "center",
              background:
                "linear-gradient(to right, #e32249, #e01171)" /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */,
            }}
          >
            <div className="col-md-8">
              <h1 className="text-white text-right mb-5">
                تعهد ما به شما تولید محتوای با کیفیت است
              </h1>
              <p className="text-white text-right" dir="rtl">
                از این نقطه به بعد ارتباط ما شکل جدیدی به خود خواهد گرفت و تمام
                توان تیم فرامحتوا برای بهبود کسب و کار شما به کار گرفته خواهد
                شد.
              </p>
            </div>
          </div>
        </div>
        <div className="snackbar">
          <strong>فیلد های مورد نیاز را پر کنید</strong>
        </div>
      </div>
      <ToastContainer rtl={true} />
    </Aux>
  );
};
const mapStateToProps = (state) => {
  return {
    url: state.url,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    onLoginSuccess: (token) => dispatch(loginSucced(token)),
    onLoginFailure: (err) => dispatch(loginFailed(err)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
